import React from "react";
import Applet from "../../Applet";
import AdminPrivilegeTable from "../../../../components/Administration/AdminRolePrivilegeTable";

class AdminRolePrivilegeTableApplet extends Applet {

    render() {
        return <AdminPrivilegeTable applet={this}
                                   pageSize={this.state.PageSize}
                                   placement={this.state.Placement}
                                   columns={this.state.Columns}
                                   title="Privileges"
                                   enterpriseComponent={this.getEnterpriseComponent()}
                                   sort={this.state.Sort}
                                   menu={this.state.Menu}
                                   rowHeight={this.state.RowHeight}
                                   simpleSearch={this.state.SimpleSearch}

        />;
    }

    state = {
        Name: "AdminPrivilegeTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Add Privilege To Role",
                    value: "New Privilege",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                }
            ],
        },
        RowHeight: 55,
        PageSize: {
            "default": 5,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 10,
            "lx": 10,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "Actions",
                },
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }],
            },
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "Name",
                                },
                                {
                                    id: "CreatedDatetime",
                                },
                                {
                                    id: "LastModifiedDatetime",
                                },
                            ]
                        }
                    ]
                }
            },
            Controls: {
                "Name": {
                    id: "Name",
                    enterpriseComponentAttribute: "Name",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Name",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "CreatedDatetime": {
                    id: "CreatedDatetime",
                    enterpriseComponentAttribute: "CreatedDatetime",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 3,
                            md: 3,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Created On",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "DateTime",
                    requiresConfirmation: false,
                },
                "LastModifiedDatetime": {
                    id: "LastModifiedDatetime",
                    enterpriseComponentAttribute: "LastModifiedDatetime",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 3,
                            md: 3,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Updated On",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "DateTime",
                    requiresConfirmation: false,
                },
            }
        }
    };
}

export default AdminRolePrivilegeTableApplet;
